import fr from 'facet-rest';
import { FDHeadlineText, FDTitleText, FDStat } from '@facet-wealth/design';


export default fr
  .metaOverride()
  .override(
    { readonly: true, type: 'string' },
    {
      _component: () => FDStat,
    },
    { ordinal: 201 },
  )
  .nameOverride(
    'year',
    {
      _component: () => FDHeadlineText,
      _customProps: {
        size: 'sm',
      },
    },
    { ordinal: 202 },
  )
  .nameOverride(
    'title',
    {
      _component: () => FDTitleText,
    },
    { ordinal: 202 },
  );
